<template>
  <div id="loginPage" class="pageWrapper">
    <div class="container">
      <div class="loginForm">
        <div class="loginFormHeader">
          <img
            src="@/assets/logo/next-era-logo.png"
            alt="VIR Logo"
          />
        </div>
        <template v-if="template === 'forgot'">
          <div class="loginFormBody">
            <div class="loginFormRow">
              <label for="email">Email Address</label>
              <input type="email" name="email" v-model="email" />
            </div>
          </div>
          <div class="loginFormFooter">
            <button @click="onClickBackToLogin">Back</button>
            <button @click="onClickForgotPasswordSubmit">Submit</button>
          </div>
        </template>
        <template v-if="template === 'register'">
          <div class="loginFormBody">
            <div class="loginFormRow">
              <label for="email">Email Address</label>
              <input type="email" name="email" v-model="email" />
            </div>
          </div>
          <div class="loginFormFooter">
            <button @click="onClickBackToLogin">Back</button>
            <button @click="onClickCheckRegisterSubmit">Request Access</button>
          </div>
        </template>

        <template v-if="template === 'requested'">
          <div class="requested">
            <p class='blue'>An email has been sent to you to complete your registration process!</p>
            <p class='icon'><img src="@/assets/icon/warning.svg" alt=""></p>
            <p class="grey">Please note that this email <span class="red">will expire in 1 hour.</span><br/>You must complete the process within that time.</p>
          </div>
          <div class="loginFormFooter">
            <button @click="onClickBackToLogin">Back to Login</button>
          </div>
        </template>

        <template v-if="template === 'reset'">
          <div class="loginFormBody">
            <div class="loginFormRow description">
              Your new password must include the following:
              <ul>
                <li>At least 8 characters in length</li>
                <li>At least 1 uppercase letter</li>
                <li>At least 1 lowercase letter</li>
                <li>At least 1 number</li>
                <li>At least 1 special character: ~`!@#$%^&*()-_+={}[]|\;:"<>,./?</li>
              </ul>
            </div>
            <div class="loginFormRow">
              <label for="email">Email Address</label>
              <input type="email" name="email" v-model="email" />
            </div>
            <div class="loginFormRow">
              <label for="password">Password</label>
              <input
                type="password"
                name="password"
                v-model="password"
                @keyup.enter="onClickLogin"
              />
            </div>
            <div class="loginFormRow">
              <label for="password">Re-Type New Password</label>
              <input
                type="password"
                name="password"
                v-model="password2"
                @keyup.enter="onClickLogin"
              />
            </div>
          </div>
          <div class="loginFormFooter">
            <button @click="onClickBackToLogin">Back</button>
            <button @click="onClickResetPasswordSubmit">Submit</button>
          </div>
        </template>

        <template v-if="template === 'login'">
          <div class="loginFormBody">
            <div class="loginFormRow">
              <label for="email">Email Address</label>
              <input type="email" name="email" v-model="email" />
            </div>
            <div class="loginFormRow">
              <label for="password">Password</label>
              <input
                type="password"
                name="password"
                v-model="password"
                @keyup.enter="onClickLogin"
              />
            </div>
            <div class="loginFormRow forgotPassword">
              <button @click="onClickForgotPassword">Forgot Password</button>
            </div>
          </div>
          <div class="loginFormFooter">
            <button @click="onClickLogin">Login</button>     
            <div class='register'>
              <button @click="onClickCheckRegister">Haven't created an account yet? Click here.</button>
            </div>       
          </div>          
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      password: "",
      password2: "",
      template: "login",
      passwordResetToken: null,
      passwordResetEmail: null,
    };
  },
  methods: {
    async onClickLogin() {
      if (!this.email || !this.password) {
        this.$swal(
          "Error!",
          "Enter a valid email address and password to login",
          "error"
        );
        return;
      }

      const response = await axios.post("user/login", {
        email: this.email.toLowerCase(),
        password: this.password,
        user_role: "user",
      });
      if (response.data.status == "success") {
        let user = response.data.user;
        localStorage.setItem("token", response.data.access_token);
        this.$store.dispatch("user", user);

        if (user.agreedTerm) {
          this.$router.push(`/topics/${user.id}`);
        } else {
          this.$router.push(`/about`);
        }
      } else {
        this.$swal("Error!", "Incorrect username and password", "error");
      }
    },
    onClickCheckRegister() {
      this.template = "register";
    },
    onClickCheckRegisterSubmit() {
      if (!this.email) {
        this.$swal("Error!", "Enter a valid email address", "error");
        return;
      }
      axios.post("user/request", {
        email: this.email.toLowerCase(),
      }).then(this.onRequestAccess).catch(this.accessError);

    },
    onRequestAccess(response) {
      if (response.data.status == "success") {
        this.$swal("Success!", "An email has been sent to you to complete the registration process. If you don’t receive it, please check your spam folder or contact neestories@heritagewerks.com.", "success");
      }
      this.template = "requested";
    },
    accessError() {
      this.$swal("Success!", "An email has been sent to you to complete the registration process. If you don’t receive it, please check your spam folder or contact neestories@heritagewerks.com.", "success");
      this.template = "requested";
    },
    onClickForgotPassword() {
      this.template = "forgot";
    },
    onClickBackToLogin() {
      this.template = "login";
    },    
    async onClickForgotPasswordSubmit() {
      if (!this.email) {
        this.$swal("Error!", "Enter a valid email address", "error");
        return;
      }

      const response = await axios.post("user/forgot", {
        email: this.email.toLowerCase(),
      });

      this.template = "login";
      this.$swal(
        "Success!",
        "If this account is valid, you will receive password reset instructions in your inbox",
        "success"
      );
      return;
    },
    async onClickResetPasswordSubmit() {
      if (!this.email) {
        this.$swal("Error!", "Enter a valid email address", "error");
        return;
      }
      if (this.email.toLowerCase() != this.passwordResetEmail.toLowerCase()) {
        window.console.log(this.email);
        window.console.log(this.passwordResetEmail);
        this.$swal("Error!", "The email address does not match", "error");
        return;
      }
      let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()-_+={}[]|\\;:"<>,.\/?])[A-Za-z\d~`!@#$%^&*()-_+={}[]|\\;:"<>,.\/?]{8,30}$/;

      if (
        this.password.match(passwordRegex) !== null &&
        this.password2.match(passwordRegex) !== null &&
        this.password === this.password2
      ) {
        const response = await axios.post("user/reset", {
          email: this.passwordResetEmail.toLowerCase(),
          password: this.password,
          password_confirmation: this.password2,
          token: this.passwordResetToken
        });

        if (response.data.status == "success") {
          this.template = "login";
          this.$router.replace({'query': null});
          this.$swal(
            "Success!",
            "You have successfully reset your password.",
            "success"
          );
        } else {
          this.$swal("Error!", "Please contact the admin to reset your password", "error");
        }
      } else {
        this.$swal(
          "Error!",
          "Your password doesn't match or the format is invalid",
          "error"
        );
      }
    },
  },
  created() {
    if(this.$route.query.token) {
      //console.log('reset token')
    } else {
      //console.log('no reset token')
      localStorage.removeItem("token");
      this.$store.dispatch("user", null);
      this.$router.push("/login");
      this.$store.dispatch("mobileMenu", false);
    }
  },
  mounted() {
    console.log('Login mounted', this.$route.query.token)
    this.passwordResetToken = this.$route.query.token
      ? this.$route.query.token
      : null;
    this.passwordResetEmail = this.$route.query.email
      ? decodeURIComponent(this.$route.query.email)
      : null;

    if (this.passwordResetToken && this.passwordResetEmail) {
      this.template = "reset";
    }
  },
};
</script>
<style lang="scss">
#app{
  &._login_page{
    overflow: hidden;  
  }
}
</style>
<style lang="scss" scoped>
.icon {
  text-align: center;
  padding:15px;
  img {
    display: inline;
  }
}
.blue, .grey {  
  font-family: "Effra-Regular";
  font-size: 15px;
  text-align: center;
  padding:0;
  margin:0;
}
.grey {
  color: #000;
  margin-bottom:15px;
}
.blue {
  color: #009ad6;
}
.red {
  color:#B30419;
  text-decoration: underline;
}
.pageWrapper .loginForm .loginFormFooter .register {
  //text-align: left;
  margin-top:15px;
  button {
    border: 0;
    background: transparent;
    color: #009ad6;
    font: inherit;
    font-family: "Effra-Regular";
    font-size: 15px;
    text-align: left;
    font-family: inherit;
    outline: none;
    text-transform: none;
    padding:0;
    margin:0;
    
  }
}
.pageWrapper {
  background-image: url("~@/assets/bg/bg-login.jpg");
  background-size: cover;
  background-position: center center;

  .container {
    position: relative;
  }

  .loginForm {
    background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
    box-shadow: 0 6px 14px 0 rgba(0, 0, 0, 0.5);
    border-radius: 0 0 8px 8px;
    max-width: 400px;
    padding: 40px 30px 28px 30px;
    position: absolute;
    top: -70px;
    z-index: 2;
    right: 0;

    @media (max-width: $lg) {
      top: 0;
      left: 0;
      position: fixed;
      height: 100%;
      width: 100%;
      max-width: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      //justify-content: space-evenly;
      max-height: 100vh;
      overflow: auto;
    }

    .loginFormHeader {
      margin-bottom: 24px;
      img {
        max-width: 347px;

        @media (max-width: $lg) {
          max-width: 150px;
        }
      }
    }
    .loginFormBody {
      @media (max-width: $lg) {
        width: 100%;
      }
      .loginFormRow {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 24px;

        &.forgotPassword {
          margin-top: -17px;
          button {
            border: 0;
            background: transparent;
            color: #009ad6;
            font-family: "Effra-Regular";
            font-size: 15px;
            text-align: left;
            outline: none;
          }
        }

        &.description {
          font-family: Effra-Regular;
          font-size: 13px;
          color: #5f5f5f;
          letter-spacing: 0;
          line-height: 19px;
          margin-bottom: 10px;
          ul {
            padding-left: 15px;
          }
        }

        label {
          font-family: Effra-Regular;
          font-size: 16px;
          color: #000000;
          letter-spacing: 0;
          margin-left: 15px;
          margin-bottom: 9px;
        }
        input {
          background: #eaeaea;
          border-radius: 5px;
          font-family: Effra-Regular;
          font-size: 16px;
          color: #000000;
          letter-spacing: 0;
          border: 0px;
          padding: 5px;
        }
      }
    }
    .loginFormFooter {
      text-align: center;
      button {
        background: #009ad6;
        border-radius: 5px;
        font-family: Effra-Heavy;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        text-transform: uppercase;
        border: 0px;
        padding: 2px 30px;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
}
</style>